export interface IHttpError {
    data?: unknown;
    headers?: Record<string, unknown>;
    statusCode?: number;
    statusText?: string;
}

export class HttpError extends Error {
    statusCode?: number;

    data?: unknown;

    statusText?: string;

    headers?: Record<string, unknown>;

    constructor(message: string, { data, headers, statusCode, statusText }: IHttpError) {
        super(message);
        this.name = 'HttpError';
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.data = data;
        this.headers = headers;
    }
}
